var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricCarsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 111,
    viewBox: "0 0 110 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1686 15.5442C36.3829 15.5442 30.2324 19.5367 27.4699 25.7345L16.292 50.813C9.59104 51.2734 4.29688 56.8514 4.29688 63.6692V76.5598C4.29688 82.4925 9.10636 87.302 15.0391 87.302H17.9835C17.9994 86.4753 18.0204 85.6488 18.0469 84.8223C17.3476 83.3968 16.9533 81.7945 16.9533 80.0996L16.7578 72.4778C16.7578 66.8412 17.9046 61.6641 22.0885 60.8212C24.0773 60.4206 25.7424 59.0656 26.5573 57.2076L40.3605 25.7345C43.1228 19.5367 49.2733 15.5442 56.0592 15.5442H43.1686Z",
    fill: "#CEE1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9609 87.302C100.894 87.302 105.703 82.4925 105.703 76.5598V63.6692C105.703 56.5499 99.9318 50.7786 92.8125 50.7786L79.5736 24.9705C76.6474 19.1888 70.7184 15.5442 64.2383 15.5442H43.1686C36.3829 15.5442 30.2324 19.5367 27.4699 25.7345L16.292 50.813C9.59104 51.2734 4.29688 56.8514 4.29688 63.6692V76.5598C4.29688 82.4925 9.10636 87.302 15.0391 87.302",
    stroke: "#405FF2",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0268 95.8958C42.773 95.8958 46.6206 92.0482 46.6206 87.302C46.6206 82.5558 42.773 78.7083 38.0268 78.7083C33.2806 78.7083 29.4331 82.5558 29.4331 87.302C29.4331 92.0482 33.2806 95.8958 38.0268 95.8958Z",
    stroke: "#405FF2",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1641 87.302H49.8433",
    stroke: "#405FF2",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9727 95.8958C76.7189 95.8958 80.5664 92.0482 80.5664 87.302C80.5664 82.5558 76.7189 78.7083 71.9727 78.7083C67.2265 78.7083 63.3789 82.5558 63.3789 87.302C63.3789 92.0482 67.2265 95.8958 71.9727 95.8958Z",
    stroke: "#405FF2",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5608 67.5363L63.5304 55.9298C65.9362 53.5786 64.2729 49.4911 60.9101 49.4911H49.9475C46.5786 49.4911 44.9182 45.3904 47.3367 43.0433L59.7328 31.0129",
    stroke: "#FF5CF3",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricCarsvg);
export default __webpack_public_path__ + "static/media/electric-car.svg.8c3d465de30e841a09eb35eddb05eaa7.svg";
export { ForwardRef as ReactComponent };